import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Calendar } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { label: 'O NAS', href: '/#onas' },
    { label: 'DIAGNOSTYKA ADHD', href: '/#adhd' },
    { label: 'OFERTA', href: '/#oferta' },
    { label: 'REJESTRACJA', link: '/rezerwacja' },
    { label: 'KONTAKT', href: '/#kontakt' },
  ];

  return (
    <nav className="w-full py-3 bg-darkGrey text-[#fdfcf9] relative z-50">
      {/* Desktop */}
      <div className="hidden md:grid grid-cols-[1fr_auto_1fr] items-center max-w-screen-2xl mx-auto px-6 lg:px-10 h-20 gap-6">
        {/* Left nav */}
        <div className="flex items-center gap-6 min-w-0">
          {navLinks.map((item, idx) =>
            item.link ? (
              <Link
                key={idx}
                to={item.link}
                className="text-xs tracking-widest font-medium text-[#fdfcf9] hover:text-[#d2a391] transition whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={idx}
                href={item.href}
                className="text-xs tracking-widest font-medium text-[#fdfcf9] hover:text-[#d2a391] transition whitespace-nowrap"
              >
                {item.label}
              </a>
            )
          )}
        </div>

        {/* Center logo */}
        <div className="justify-self-center">
          <Link
            to="/"
            className="text-lg font-alike tracking-[0.15em] text-[#fdfcf9] whitespace-nowrap"
          >
            PSYCHOTERAPIA Marciniec
          </Link>
        </div>

        {/* Right: phone + rezerwuj */}
        <div className="flex items-center gap-4 justify-self-end">
          <a
            href="tel:665189478"
            className="flex items-center gap-2 bg-[#e8e4dc] text-darkGrey text-sm font-semibold py-2 px-4 rounded-md hover:opacity-90 transition whitespace-nowrap"
          >
            <Phone size={16} /> 665 189 478
          </a>

          <Link
            to="/rezerwacja"
            className="flex items-center gap-2 bg-[#b98870] text-white text-sm font-semibold py-2 px-4 rounded-md hover:opacity-90 transition whitespace-nowrap"
          >
            <Calendar size={16} /> REZERWUJ TERMIN
          </Link>
        </div>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden items-center justify-between px-4">
        <span className="font-alike text-base text-[#fdfcf9]">
          PSYCHOTERAPIA Marciniec
        </span>
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <X className="w-6 h-6 text-[#fdfcf9]" />
          ) : (
            <Menu className="w-6 h-6 text-[#fdfcf9]" />
          )}
        </button>
      </div>

      {/* Mobile dropdown */}
      {isOpen && (
        <div className="md:hidden bg-darkGrey border-t border-[#e8e4dc] px-6 py-6 flex flex-col gap-4 text-center">
          {navLinks.map((item, idx) =>
            item.link ? (
              <Link
                key={idx}
                to={item.link}
                onClick={() => setIsOpen(false)}
                className="text-base text-[#fdfcf9] font-medium hover:text-[#d2a391] transition"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={idx}
                href={item.href}
                onClick={() => setIsOpen(false)}
                className="text-base text-[#fdfcf9] font-medium hover:text-[#d2a391] transition"
              >
                {item.label}
              </a>
            )
          )}

          <a
            href="tel:665189478"
            className="flex justify-center items-center gap-2 bg-[#e8e4dc] text-darkGrey text-sm font-semibold py-2 px-4 rounded-md hover:bg-[#d2a391] hover:text-white"
          >
            <Phone size={16} /> 665 189 478
          </a>

          <Link
            to="/rezerwacja"
            onClick={() => setIsOpen(false)}
            className="flex justify-center items-center gap-2 bg-[#b98870] text-white text-sm font-semibold py-2 px-4 rounded-md hover:opacity-90"
          >
            <Calendar size={16} /> REZERWUJ TERMIN
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
